import { Modal, Button } from "react-bootstrap";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

function ToggleFeatureModal({
  show,
  onClose,
  onConfirm,
  featureName,
  currentStatus,
}) {
  const { t } = useTranslation();

  const newStatus = !currentStatus;
  const action = newStatus ? t("habilitar") : t("desabilitar");

  return (
    <Modal backdrop="static" centered size="md" show={show} onHide={onClose}>
      <Modal.Header closeButton closeVariant="white">
        <Modal.Title>
          {newStatus ? t("Habilitar Feature") : t("Desabilitar Feature")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          {t("confirm_really")} {action} {t("the_feature")}{" "}
          <strong>{featureName}</strong> {t("question_mark")}
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          {t("button_cancel")}
        </Button>
        <Button variant="primary" onClick={onConfirm}>
          {t("button_confirm")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

ToggleFeatureModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  featureName: PropTypes.string,
  currentStatus: PropTypes.bool,
};

export default ToggleFeatureModal;
